import { RpcHealth, RpcConfig, NetworkType } from '@/config/types/rpc';
import { JsonRpcProvider } from 'ethers';

class RpcManager {
  private static instance: RpcManager;
  private currentRpcs: Record<NetworkType, string> = {} as Record<NetworkType, string>;
  private rpcConfig?: Record<NetworkType, RpcConfig>;

  private constructor() {}

  public static getInstance(): RpcManager {
    if (!RpcManager.instance) {
      RpcManager.instance = new RpcManager();
    }
    return RpcManager.instance;
  }

  public setConfig(config: Record<NetworkType, RpcConfig>) {
    this.rpcConfig = config;
    this.initializeRpcs();
  }

  private initializeRpcs() {
    if (!this.rpcConfig) return;

    // Simply use the first available RPC for each network
    Object.entries(this.rpcConfig).forEach(([network, config]) => {
      this.currentRpcs[network as NetworkType] = config.primary[0] || config.backup[0];
    });
  }

  public getCurrentRpc(network: NetworkType): string {
    return this.currentRpcs[network] || this.rpcConfig?.[network]?.primary[0] || this.rpcConfig?.[network]?.backup[0];
  }

  public async switchRpc(network: NetworkType): Promise<void> {
    if (!this.rpcConfig) return;

    const config = this.rpcConfig[network];
    const currentRpc = this.currentRpcs[network];
    
    // Get all available RPCs
    const allRpcs = [...config.primary, ...config.backup];
    
    // Find current RPC index
    const currentIndex = allRpcs.indexOf(currentRpc);
    
    // Switch to next RPC in the list, or go back to first
    const nextIndex = (currentIndex + 1) % allRpcs.length;
    this.currentRpcs[network] = allRpcs[nextIndex];
  }
}

export const rpcManager = RpcManager.getInstance();
